import { Animation } from '../../../../interface';

export function enterAnimationTop(AnimationC: Animation, baseEl: HTMLElement): Promise<Animation> {
  const baseAnimation = new AnimationC();

  const wrapperAnimation = new AnimationC();
  wrapperAnimation.addElement(baseEl.querySelector('.lar-notify-wrapper'));

  // Simple fade-in animation
  wrapperAnimation.fromTo('opacity', '0', '1');

  return Promise.resolve(baseAnimation
    .addElement(baseEl)
    .easing('ease-in')
    .duration(300)
    .add(wrapperAnimation));
}
